<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      :close-on-popstate="true"
      :style="{ height: '40%' }"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @change="onChange"
        @confirm="onConfirm"
        @cancel="onCancel"
        ref="ldpicker"
      />
    </van-popup>
  </div>
</template>

<script>
import { Picker, Popup } from 'vant'
import { formatDate } from 'Utils/dateUtil'

function hours(){
  var arr=[]
  for(var i=0;i<24;i++){
    var k=i+'点'
    arr.push({text:k,value:i<10?('0'+i):i})
  }
  return arr
}
function mins(){
  return [
    {text:'00',value:'00'},
    {text:'10',value:'10'},
    {text:'20',value:'20'},
    {text:'30',value:'30'},
    {text:'40',value:'40'},
    {text:'50',value:'50'},
  ]
}
export default {
  name:'LdDatePicker',
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  props: {
    minDate:{
      type: String,
      default: ''
    },
    maxDate:{
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isShow: false,
      columns: [{
        values: [],
        defaultIndex: 3
      },{
        values: hours(),
        defaultIndex: 2
      },{
        values: mins(),
        defaultIndex: 1
      }],
      monthDays:60
    }
  },
  created() {
    this.init()
  },
  mounted(){
    this.$nextTick( () => {
      // Code that will run only after the
      // entire view has been rendered
    })
  },
  methods: {
    init(){
      if(this.minDate&&this.maxDate){
        this.monthDays=this.getMonDays(this.minDate)+this.getMonDays(this.maxDate)
      }
      this.initMonth()
      this.initHours()
      this.initMins()
    },
    initMonth(){
      let minDate=(this.minDate?this.minDate:new Date())
      let arr=[]
      for(let i=0;i<this.monthDays;i++){
        let obj=formatDate(minDate,i)
        arr.push({text:`${obj.monDay} ${obj.week}`,value:obj.date,value1:obj.date3})
      }
      this.columns[0].values=arr
    },
    initHours(){
      let nowday=formatDate()
      let hours=this.columns[1].values.filter(item =>{
        if(item.value==nowday.h&&nowday.mins<50){
          return true
        }
        return item.value>nowday.h
      })
      this.columns[1].values=hours
    },
    initMins(){
      let nowday=formatDate()
      if(nowday.mins<=50){
        let mins=this.columns[2].values.filter(item =>{
          return item.value>=nowday.mins
        })
        this.columns[2].values=mins
      }
    },
    getMonDays(date){//获取指定月份天数
      if(date){
        var date = new Date(date)
      }else{
        var date = new Date()
      }
      var year = date.getFullYear()
      var month = date.getMonth()+1
      var d = new Date(year, month, 0)
      return d.getDate()
    },
    onChange (picker, values) {
      //获取所有列选中值对应的索引this.$refs.ldpicker.getIndexes()
      //	获取对应列选中项的索引this.$refs.ldpicker.getColumnIndex(2)
      let indexes = this.$refs.ldpicker.getIndexes()
      if(indexes[0]==0){
        this.initHours()
        let index=this.$refs.ldpicker.getColumnIndex(1)
        if(index==0){
          this.initMins()
        }
      }else if(indexes[0]>0){
        this.columns[1].values=hours()
        this.columns[2].values=mins()
      }
      if(indexes[1]>0){
        this.columns[2].values=mins()
      }
    },
    onConfirm (picker, values) {
      let obj={
        monDayWeek:picker[0].text,
        date:picker[0].value,
        date1:picker[0].value1,
        hm:`${picker[1].value}:${picker[2].value}`
      }
      this.$emit('confirm',obj)
      this.toggle()
    },
    onCancel () {
      this.toggle()
    },
    toggle(){
      this.isShow=!this.isShow
      if(this.isShow){
        this.$nextTick( () => {
          // 设置所有列选中值对应的索引
          this.$refs.ldpicker.setIndexes([0,0,0])
        })
      }
    }
  },
  watch: {
  }
}
</script>
<style scoped lang="less">
@deep:~'>>>';
  @{deep}.van-picker__columns{
    padding-left:20px;
}
</style>